import axios from "axios";
const isDevEnv = process.env.NODE_ENV === "development";

const videoHandler = axios.create();
const baseURL = isDevEnv ? "https://app.rattvisat.se" : window.location.origin;

async function uploadVideo(file) {
  let packache = new FormData();
  packache.append("file", file);

  if (file.size > 1024 * 1024 * 1024) throw "FTB1500";

  const response = await videoHandler.post(baseURL + "/uploadVideo", packache);
  return response.data.fileName;
}

async function deleteVideo(fileName) {
  const response = await axios.delete(baseURL + "/deleteVideo/" + fileName);
  return response;
}

async function getStreamingUrls(fileName) {
  const response = await axios.get(baseURL + "/getstreamingurls/" + fileName);
  return response.data;
}

export default {
  uploadVideo,
  deleteVideo,
  getStreamingUrls,
};
